import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setAuthObj } from '../../actions/index';
import LoadingComponent from '../commonComponents/LoadingComponent';
// import ColorPicker from '../commonComponents/ColorPicker';
import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';
import Form from '../../../adminpanel/components/commonComponents/Form';

class SettingsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: null
        }
        this.refreshPage = this.refreshPage.bind(this);
    }

    componentWillMount() {
        let that = this, decodedResponse = null;
        let params = { 'siteId': this.props.authData.siteId }
        let postData = { 'userId': this.props.authData.userId }
        CallAPI('POST', '/app/get_company_auth_data', postData, params, 0, function (response) {
            if (response.status)
                decodedResponse = decodePassword(response.value[0])
            that.setState({ data: decodedResponse ? JSON.parse(decodedResponse) : null });
        }, this.props.authData)
    }

    onSubmit = (e) => {
        e.preventDefault();
        let submitUserResponse = confirm("Please Confirm to Update.");
        if (submitUserResponse === true) {
            let form_array = jQuery("#layout_custom").serializeArray();
            let paramArray = {}, checkValidity = true
            form_array.map(function (innerData) {
                if (innerData.name === 'logo') {
                    paramArray[innerData.name] = innerData.value.toLocaleLowerCase()
                } else paramArray[innerData.name] = innerData.value;
            })
            checkValidity = checkValidity ? (checkSpecialChars(paramArray['logo']) ? false : true) : false
            if (checkValidity === false) {
                alert('Please enter valid inputs!\n(Only alphabets, hyphen(-) & underscore(_) are allowed.)');
            } else {
                let params = { siteId: this.props.authData.siteId }
                paramArray['userId'] = this.props.authData.userId
                var that = this
                this.setState({ updateResponse: false })
                CallAPI('POST', '/app/update_company_auth_data', paramArray, params, 0, function (response) {
                    if (response.status) {
                        let authObj = that.props.authData;
                        authObj.extraInfo = JSON.stringify(paramArray);
                        that.props.setAuthObj(authObj);
                        // that.setState({ updateResponse: true, error: '' })
                        alert("Settings uploaded successfully.")
                    }
                }, this.props.authData)
            }
        }
    }
    refreshPage() {
        window.location.reload()
    }
    render() {
        var mainData = <LoadingComponent />;
        // console.log(this.state)
        if (this.state.data) {
            let initialData = [];
            var fetchData = JSON.parse(this.state.data.extra_info);
            // console.log(fetchData)
            initialData['SKIN_MODE'] = fetchData && fetchData.SKIN_MODE ? fetchData.SKIN_MODE : 'default';
            initialData['SKIN_NAV'] = fetchData && fetchData.SKIN_NAV ? fetchData.SKIN_NAV : 'deepblue';
            initialData['logo'] = fetchData && fetchData.logo ? fetchData.logo : 'rockmetric';
            initialData['NAV_TYPE'] = fetchData && fetchData.NAV_TYPE ? fetchData.NAV_TYPE : '0';
            initialData['TOP_SETTING'] = fetchData && fetchData.TOP_SETTING ? fetchData.TOP_SETTING : '1';
            initialData['NAV_STATUS'] = fetchData && fetchData.NAV_STATUS ? fetchData.NAV_STATUS : '1';
            initialData['user_login_allow'] = fetchData && fetchData.user_login_allow ? fetchData.user_login_allow : 0
            initialData['dashboard_display_type'] = fetchData && fetchData.dashboard_display_type ? fetchData.dashboard_display_type : ''
            let bulkFormData = {
                "SKIN_MODE": {
                    "name": "SKIN_MODE", "label": "Skin Mode", "text_value": initialData['SKIN_MODE'], "type": "dropdown", "options": [
                        { "name": "Classic", "value": "default" },
                        // { "name": "Light", "value": "light" },
                        // { "name": "Cool", "value": "cool" },
                        // { "name": "Dark (Beta)", "value": "dark" },
                    ]
                },
                "SKIN_NAV": {
                    "name": "SKIN_NAV", "label": "Navigation Skin", "text_value": initialData['SKIN_NAV'], "type": "dropdown", "options": [
                        { "name": "Deepblue", "value": "deepblue" },
                        { "name": "Charcoal", "value": "charcoal" },
                        { "name": "Gradient", "value": "gradient1" },
                        { "name": "Default", "value": "default" },
                    ]
                },
                "logo": { "name": "logo", "label": "Change Logo", "text_value": initialData['logo'], "type": "text" },
            }
            let bulkFormDataSecond = {
                "NAV_TYPE": {
                    "name": "NAV_TYPE", "label": "Navbar Location", "text_value": initialData['NAV_TYPE'], "type": "dropdown", "options": [
                        { "name": "Horizontal", "value": "1" },
                        { "name": "Vertical", "value": "0" },
                    ]
                },
                "TOP_SETTING": {
                    "name": "TOP_SETTING", "label": "Top Bar", "text_value": initialData['TOP_SETTING'], "type": "dropdown", "options": [
                        { "name": "Enable", "value": "1" },
                        { "name": "Disable", "value": "0" },
                    ]
                },
                "NAV_STATUS": {
                    "name": "NAV_STATUS", "label": "Nav Status", "text_value": initialData['NAV_STATUS'], "type": "dropdown", "options": [
                        { "name": "Enable", "value": "1" },
                        { "name": "Disable", "value": "0" },
                    ]
                },
                "user_login_allow": {
                    "name": "user_login_allow", "label": "Concurrent Logins Allowed", "type": "number", "text_value": initialData['user_login_allow']
                },
                'dashboard_display_type': {
                    'name': 'dashboard_display_type', 'label': 'Dashboard UI Type', 'text_value': initialData['dashboard_display_type'], 'type': 'dropdown', 'options': [
                        { "name": 'Breadcrumb Dropdown', "value": "dropdown" },
                        { "name": 'Tabs', "value": "tabs" },
                    ]
                },
            }
            var Bulk_Form_Data = <Form label_array={bulkFormData} call_back={this.call_back_form} />;
            var Bulk_Form_Data_Second = <Form label_array={bulkFormDataSecond} call_back={this.call_back_form} />;
            return (
                <div id="main-content" className='wd-300'>
                    {this.state.updateResponse === true ?
                        <div class="alert alert-success" role="alert" style={{ marginLeft: '13px' }}>
                            <strong>Success! </strong> Configuration updated successfully! <a href="javascript:void(0)" onClick={this.refreshPage.bind(this)}>Click here to refresh</a>
                        </div>
                        : null}
                    <div className="form-group row pd-l-5 ">
                        <form id="layout_custom" onSubmit={this.onSubmit}>

                            {Bulk_Form_Data}

                            {Bulk_Form_Data_Second}

                            <div className='row pd-x-12'>
                                <button type='submit' className="btn btn-sm btn-primary pd-l-0 w-100">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            )
        }
        return (
            <div id="main-content" className='w-20'>
                {mainData}
            </div>
        )
    }
}


function mapStateToProps(state) {
    return { authData: state.dataSet.authData };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setAuthObj
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsComponent);